import React, { FC } from 'react';
import { turn_on } from '@jat-med/assets';
import { ITableActivateButtonProps } from './tableActivateButton.interface';
import styles from './tableActivateButton.module.scss';
import { useTranslation } from 'react-i18next';

export const TableActivateButton: FC<ITableActivateButtonProps> = ({
 onClick,
}) => {
 const { t } = useTranslation();
 return (
  <button
   className={styles.table_activate_button}
   onClick={onClick}
   title={t('buttons.activate')}
  >
   <img src={turn_on} alt='activate_btn' />
  </button>
 );
};
